<template>
    <div class="animated fadeIn">
        <div class="card">
            <div class="card-header">
                {{aLang.c_list}} {{aLang.ads_title}}
                <div class="card-header-actions"></div>
            </div>
            <div class="card-body">
                <b-row>
                    <b-col md="8">
                        <div class="text-left mb-0">
                            <b-row>
                                <b-col class="col-md-4">
                                    <el-select
                                        v-model="mData.tableRules.dataSearch.value.vi_tri"
                                        :placeholder="aLang.ads_screen"
                                        :disabled="mData.viewMode == 'detail'"
                                        @change="fn_tableSearch()"
                                        clearable
                                        filterable
                                    >
                                        <el-option
                                            v-for="item in mData.dataDefault.listManHinh"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </b-col>
                                <b-col class="col-md-4">
                                    <el-select
                                        v-model="mData.tableRules.dataSearch.value.hien_thi"
                                        :placeholder="aLang.ads_visible"
                                        :disabled="mData.viewMode == 'detail'"
                                        @change="fn_tableSearch()"
                                        clearable
                                        filterable
                                    >
                                        <el-option
                                            v-for="item in mData.dataDefault.listHienThi"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </b-col>
                                <b-col class="col-md-4">
                                    <el-select
                                        v-model="mData.tableRules.dataSearch.value.ngon_ngu"
                                        :placeholder="aLang.nc_language"
                                        :disabled="mData.viewMode == 'detail'"
                                        @change="fn_tableSearch()"
                                        clearable
                                        filterable
                                    >
                                        <el-option
                                            v-for="item in mData.dataDefault.listNgonNgu"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                    <b-col md="4">
                        <div class="text-right mb-2">
                            <el-button @click="fn_handle('create')" type="info" plain>{{aLang.c_create}}</el-button>
                        </div>
                    </b-col>
                </b-row>
                <el-table
                    :data="mData.tableRules.data"
                    border
                    @selection-change="fn_tableSelectionChange"
                    @sort-change="fn_tableSortChange"
                    max-height="440"
                    style="width: 100%"
                    :default-sort="{prop: mData.tableRules.defaultSort[0], order: mData.tableRules.defaultSort[1]}"
                >
                    <el-table-column type="selection" width="40" v-if="mData.tableRules.allowSelect"></el-table-column>
                    <el-table-column
                        prop="noi_bat"
                        :sortable="mData.tableRules.allowSorting"
                        :label="aLang.ads_visible"
                        width="100"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-checkbox
                                v-model="scope.row.hien_thi"
                                @change="fn_changeTrangThai(scope.row.id, scope.row.hien_thi)"
                            ></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="thu_tu"
                        :label="aLang.ads_order"
                        width="70"
                        align="center"
                    >
                        <template slot-scope="scope">
                          <span class="text-center">{{ scope.row.thu_tu}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="vi_tri"
                        :sortable="mData.tableRules.allowSorting"
                        :label="aLang.ads_screen"
                        width="150"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <div class="text-center">
                                {{
                                scope.row.vi_tri === "home" ? 'Trang chủ'  :
                                scope.row.vi_tri === "login" ? 'Đăng nhập'  : ''
                                }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="ten_banner"
                        :label="aLang.ads_banner_name"
                        min-width="150"
                    ></el-table-column>
                    <el-table-column
                        prop="link_quang_cao"
                        :sortable="mData.tableRules.allowSorting"
                        :label="aLang.ads_link"
                        min-width="150"
                    ></el-table-column>
                    <el-table-column
                        prop="ngon_ngu"
                        :label="aLang.nc_language"
                        width="150"
                    >
                        <template slot-scope="scope">
                            <div class="text-center">
                                <span class="text-center">
                                  {{
                                    scope.row.ngon_ngu == "vi" ? "Tiếng Việt" :
                                    scope.row.ngon_ngu == "en" ? "Tiếng Anh" : ""
                                  }}
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :label="aLang.c_action" align="center" width="150px">
                        <template slot-scope="scope">
                            <el-button
                                size="mini"
                                @click="fn_handle('detail',scope.$index, scope.row)"
                                v-b-popover.hover.left="aLang.c_detail"
                            >
                                <i class="fa fa-eye"></i>
                            </el-button>
                            <el-button
                                size="mini"
                                @click="fn_handle('update',scope.$index, scope.row)"
                                v-b-popover.hover.left="aLang.c_update"
                            >
                                <i class="icon-pencil icons"></i>
                            </el-button>
                            <el-button
                                size="mini"
                                @click="fn_handle('delete',scope.$index, scope.row)"
                                v-b-popover.hover.left="aLang.c_delete"
                            >
                                <i class="icon-trash icons"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
                    <div class="col-md-4">
                        <div
                        v-if="mData.tableRules.allowSelect"
                        >{{aLang.c_select}}: {{mData.tableRules.recordSelected.length}}</div>
                    </div>
                    <div class="col-md-8 text-right">
                        <el-pagination
                        @size-change="fn_tableSizeChange"
                        @current-change="fn_tableCurentChange"
                        @prev-click="fn_tablePrevClick"
                        @next-click="fn_tableNextClick"
                        :page-sizes="mData.tableRules.lengthMenu"
                        :page-size="mData.tableRules.limit"
                        :current-page="mData.tableRules.page"
                        background
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="mData.tableRules.total"
                        :pager-count="5"
                        ></el-pagination>
                    </div>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import QuangCaoModel from '@/views/admin/QuangCao/QuangCaoModel';
import QuangCaoApi from '@/moduleApi/QuangCaoApi';

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        moduleName: "QuangCao", //requied
        urlImg: ExtensionService.urlImg,
        tableRules: MethodService.copyObject(QuangCaoModel.tableRules),
        dataDefault: {
            listManHinh: MethodService.copyObject(QuangCaoModel.listManHinh),
            listHienThi: MethodService.copyObject(QuangCaoModel.listHienThi),
            listNgonNgu: DataService.Languages
        }
      }
    };
  },

  methods: {
    //get list table
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router.replace({
          name: "Admin-" + this.mData.moduleName + "-list",
          query: {
            limit: this.mData.tableRules.limit,
            page: this.mData.tableRules.page,
            sort: this.mData.tableRules.sort,
            filters: this.mData.tableRules.filters,
            showFormSearch: this.mData.tableRules.showFormSearch
          }
        }).catch(err => {});
      }

      let res = await QuangCaoApi.list(dataFilter);

      this.mData.tableRules.data = res.result;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.fn_initTable();
      }
      console.log("this.mData.tableRules.data",this.mData.tableRules.data);
    },

    //xử lý dữ liệu đầu ra
    async changeData(data) {},

    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create"
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id }
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id }
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    //delete
    async fn_delete(id) {
      await QuangCaoApi.delete(id);
      this.fn_initTable();
    },

    //event table
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function(element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    // search
    fn_tableSearch() {
    //   this.$refs["myForm"].validate(async valid => {
    //     if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        // } else {
        //   MethodService.stopLadda();
        //   return false;
        // }
    //   });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query
      });
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue, index) {
      var roles = "";
      cellValue.forEach(item => {
        for (let i = 0; i < this.mData.dataDefault.roles.length; i++) {
          if (item == this.mData.dataDefault.roles[i].value) {
            item = this.mData.dataDefault.roles[i].label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },


    async fn_changeTrangThai(id, trangThai) {
        let data = {
          id: id,
          hien_thi: trangThai
        };
      await QuangCaoApi.update(data);
      this.fn_initTable();
    },

    async fn_initDataDefault() {},

    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    }
  },

  //run after render view
  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  mounted() {
    this.fn_initTable();
  }
};
</script>
<style scoped>
p{
    margin-bottom: 0;
}
</style>
